import dadosAgenciaComum from './dadosAgenciaComum';

export const dadosHumaitaPassagens = {
    ...dadosAgenciaComum,
    id: 'humaitapassagens',
    nome: 'Humaitá Passagens',
    instagram: 'instagram.com',
    facebook: 'facebook.com',
    youtube: 'youtube.com',
    email: 'suportevexado@gmail.com',
    idsTagManager: ['GTM-W66R5MP']
};
